import type { Paths } from '@/__generated__/openapi-types';
import { api } from '@/api';

export const refreshTokenMutation = () => ({
  mutationFn: async (body: Paths.RefreshToken.RequestBody) => {
    const response = await api.RefreshToken(null, body);
    return response.data;
  },
});
